module.exports = __webpack_public_path__ + "img/Scaffolding servicies on the gas plant.53390b6a.png";